<div class="card mb-0">
  <div class="card-body p-3 d-flex flex-column align-items-center">
    <img src="../../../../../assets/img/Group 5511.png" class="mb-1" alt="">
    <h1 class="mb-1 text-center">
      Welcome to the <span>Leaderboard</span>
    </h1>
    <p class="text-center">
      Welcome to the Zeraki Learning leaderboard, our very own contest that
      makes learning fun, competitive and engaging. <br />

      In order to compete on the leaderboard, earn points by doing quizzes and
      watching videos. <br />

      The more points you earn, the better you'll rank and the higher your
      chances of winning exciting prizes🎁
    </p>
    <h2 class="mb-1 mt-1 text-center">The Four Main <span>Levels</span></h2>
    <p class="text-center">
      Our leaderboard has four main levels. Each player starts from their county's
       brownze level. For example if you live in Kiambu, you'll start competing in the Kiambu Brownze level.
    </p>
    <div class="levels d-flex flex-wrap">
      <div class="level d-flex flex-column align-items-center">
        <img src="../../../../../assets/img/Group 5514.png" alt="Gold">
        <p>Gold</p>
      </div>
      <div class="level d-flex flex-column align-items-center">
        <img src="../../../../../assets/img/Group 5515.png" alt="Silver">
        <p>Silver</p>
      </div>
      <div class="level d-flex flex-column align-items-center">
        <img src="../../../../../assets/img/Group 5513.png" alt="Brownze">
        <p>Brownze</p>
      </div>
      <div class="level d-flex flex-column align-items-center">
        <img src="../../../../../assets/img/Group 5512.png" alt="Platium">
        <p>Platinum</p>
      </div>
    </div>
    <h2 class="mb-1 mt-1 text-center">Promotion and <span>Demotions</span></h2>
    <p class="text-center">
      If you make it to top 3 at the end of the week, you get promoted to the
      Kiambu Silver League. Keep up the good work for another week in the top
      three, and you'll climb to the Gold League. Do it once more, and you'll
      reach the top Platinum League.<br /><br />

      However, if you’re bottom 3 in any level, you’ll get demoted to the level
      below you. But don’t worry about this, if you’re at risk of getting
      demoted, we’ll send you a notification to encourage you to climb the ranks
      and avoid demotion.<br /><br />

      Once you reach Kiambu Platinum and you also make it to top 3, you’ll be
      promoted to the National League where you can compete with students from
      all over Kenya. And just like the County League, you’ll start from the
      National Bronze level as you work your way up to the National Platinum
      level
    </p>
    <h2 class="mb-1 mt-1 text-center">Amazing <span>Gifts</span> To Be Won</h2>
    <p class="text-center">
      Each week, players who get promoted to a new level will receive gifts and
      prizes🎁 so stay on the lookout. To compete and stand a chance to win:
    </p>
    <ol>
      <li>Earn points by doing quizzes and watching videos▶️</li>
      <li>
        Post a screenshot of your progress with the hashtag #ZerakiAchievers on
        your Instagram story🌟
      </li>
    </ol>
  </div>
</div>
